var Accordion = /** @class */ (function () {
    function Accordion() {
        this.selectors = {
            accordion: '[data-accordion]',
            trigger: '[data-accordion-trigger]',
            content: '[data-accordion-content]',
            icon: '[data-accordion-icon]'
        };
        this.nodeList = {
            accordions: document.querySelectorAll(this.selectors.accordion)
        };
    }
    Accordion.prototype.init = function () {
        var _this = this;
        this.nodeList.accordions.forEach(function (accordion) {
            _this.addEventListeners(accordion);
        });
    };
    Accordion.prototype.addEventListeners = function (accordion) {
        var trigger = accordion.querySelector(this.selectors.trigger);
        trigger.addEventListener('click', this.handleTriggerClick.bind(this, accordion));
    };
    Accordion.prototype.handleTriggerClick = function (accordion) {
        var content = accordion.querySelector(this.selectors.content);
        content.classList.toggle('active');
        content.parentNode.querySelector("h2").querySelector("span[data-accordion-icon]").classList.toggle("active");
        console.log(content);
    };
    return Accordion;
}());
export { Accordion };
;
